/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Profile_Github_ErrorInputs */



/**
* | output |
* | --- |
* | "GitHub linking error: {error}" |
*
* @param {Profile_Github_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_github_error = /** @type {((inputs: Profile_Github_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Github_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur de liaison GitHub : ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al vincular GitHub: ${i?.error}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Erro ao vincular GitHub: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore collegamento GitHub: ${i?.error}`)
	return /** @type {LocalizedString} */ (`GitHub linking error: ${i?.error}`)
});